import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=1f67dd20&scoped=true&"
import script from "./AiChatWidget.vue?vue&type=script&lang=js&"
export * from "./AiChatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67dd20",
  null
  
)

export default component.exports